//@ts-check
/**
 * 
 * @param {Fox} fox
 */
module.exports = (fox, parentPopupName) => {
    return fox.registerWidget('Popup_Common', {
        configure: function () {
            this.registerOptions('', {
                widgets: {
                    content: {
                        widget: 'Widget',
                        template: 'div.popup-content',
                        autoRender: true,
                        container: '#popup-widget-container',
                        'handleDom.close': {
                            target: '.close',
                            callback: '@parent:hide'
                        },
                        'handleDom.cloneOnParent': {
                            target: '.close',
                            targetWidget: '@parent',
                            callback: '@parent:hide'
                        }
                    }
                }
            });

            this.callParent('configure', arguments);
        }
    }, 'PopupWidget');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/common-widgets/PopupCommon.es.js